import { createSelector } from 'reselect';
import { getUserAddedManualPartCounts } from './getUserAddedManualPartCounts';
import { getScopeReadTimePCM } from './getScopeReadTimePCM';

/**
 * Selector that calculates the total number of parts added by the user
 * in the current session.
 *
 * @returns {number} The total count of parts added by user
 */
export const getTotalUserAddedManualPartCounts = createSelector(
  [getUserAddedManualPartCounts, getScopeReadTimePCM],
  (userAddedManualPartCounts, scopeReadTimePCM) => {
    return userAddedManualPartCounts.reduce((sum, action) => {
      return sum + (action.count ?? 1) * scopeReadTimePCM;
    }, 0);
  }
);
